import { render, staticRenderFns } from "./com-dialog.vue?vue&type=template&id=30dae2cc&"
import script from "./com-dialog.vue?vue&type=script&lang=js&"
export * from "./com-dialog.vue?vue&type=script&lang=js&"
import style0 from "./com-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports